import Vue from 'vue'
import Router from 'vue-router'
import ChatLayout from '@/Layouts/ChatLayout'
import HomeLayout from '@/Layouts/HomeLayout'
import ProfileLayout from '@/Layouts/ProfileLayout'
import LegalDocLayout from '@/Layouts/LegalDocumentLayout'
import TermsAndConditions from '@/LegalDocs/TermsAndConditions'
import PrivacyPolicy from '@/LegalDocs/PrivacyPolicy'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'HomePage',
            component: HomeLayout
        },
        {
            path: '/Chat',
            name: 'ChatLayout',
            component: HomeLayout
        },
        {
            path: '/Profile/:stringUrl',
            name: 'ProfileLayout',
            component: HomeLayout
        },
        {
            path: '/Doc',
            name: 'LegalDocLayout',
            component: HomeLayout,
            children: [
                {
                    path: 'TOC',
                    name: 'TermsAndConditions',
                    component: HomeLayout,
                },
                {
                    path: 'PrivacyPolicy',
                    name: 'PrivacyPolicy',
                    component: HomeLayout,
                }
            ]
        },
    ],
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/router.js